import React, { useState } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from 'sonner';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Kérjük, adja meg email címét!');
      return;
    }
    
    setLoading(true);
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
      console.log('Submitting newsletter to:', backendUrl); // Debug log

      const response = await fetch(`${backendUrl}/api/newsletter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Newsletter error:', errorText);
        throw new Error('Failed to subscribe');
      }

      const data = await response.json();
      console.log('Newsletter success:', data);
      toast.success('Sikeresen feliratkozott hírlevelünkre!');
      setEmail('');
    } catch (error) {
      console.error('Newsletter catch:', error);
      toast.error('Hiba történt a feliratkozás során. Kérjük, próbálja újra később.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-32 px-6 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="container mx-auto max-w-xl text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-serif font-normal mb-8 tracking-wide">
          Iratkozzon fel hírlevelünkre
        </h2>
        <p className="text-sm uppercase tracking-widest mb-12 text-primary-foreground/70">
          Különleges ajánlatok &gasztronómiai újdonságok
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <Input 
            type="email"
            placeholder="EMAIL CÍM"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-transparent border-b border-primary-foreground/30 text-center text-primary-foreground placeholder:text-primary-foreground/40 rounded-none h-12 focus:border-primary-foreground px-0"
            required
            disabled={loading}
          />
          <Button 
            type="submit"
            variant="outline"
            className="w-full border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary mt-4"
            disabled={loading}
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Feliratkozás'}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
